module.exports = __webpack_public_path__ + "static/media/logo-royal-caribean.651504d0.png";